module.exports = __webpack_public_path__ + "static/img/VN.c94bcc4d.png";